import React, { useEffect, useState, useRef } from "react";
import vehicle from "../assets/svg/Van.svg";
import "../App.css";
import "./OrdersMap.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { newImageUrl } from "../pages/Manufacturers/ManufactureProfile";
import defaultImage from "../assets/svg/defultImage.svg"
import { Circle, Close, Edit, LocationOn, Search } from "@mui/icons-material";
import $ from "jquery";
import { Modal } from "react-bootstrap";
import { newHost } from "../pages/Categories/CategoryProfile";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { formatNumber } from "../hooks/formatNumber";
import {
  GoogleMap,
  useJsApiLoader,
} from "@react-google-maps/api";

const GOOGLE_MAPS_LIBRARIES = ["places"]; 

export default function OrdersMap() {

  const [vanInfo, setVanInfo] = useState({});
  const [vanOrders, setVanOrders] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [vanList, setVanList] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedVanId, setSelectedVanId] = useState(null);
  const [selectVanModal, setSelectVanModal] = useState(false);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [selectedVanDetails, setSelectedVanDetails] = useState({});
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationMode, setLocationMode] = useState(null);   
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [savingLocation, setSavingLocation] = useState(false);
  const [editingStartPointId, setEditingStartPointId] = useState(null);
  const [locationType, setLocationType] = useState("start_point"); 
  const [searchValue, setSearchValue] = useState("");
  const [predictions, setPredictions] = useState([]);
  const [showPredictions, setShowPredictions] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const autocompleteServiceRef = useRef(null);
  const placesServiceRef = useRef(null);
  const sessionTokenRef = useRef(null);
  const debounceRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerInstanceRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);

  const GOOGLE_MAPS_KEY = "AIzaSyBxZBJZC4ABTmxiB2VUgNx2yMkUJ6s4u30";

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  useEffect(() => {
    if (isLoaded && window.google) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        document.createElement("div"),
      );
      sessionTokenRef.current =
        new window.google.maps.places.AutocompleteSessionToken();
    }
  }, [isLoaded]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!value.trim() || !autocompleteServiceRef.current) {
      setPredictions([]);
      setShowPredictions(false);
      return;
    }

    debounceRef.current = setTimeout(() => {
      setSearchLoading(true);
      autocompleteServiceRef.current.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: "eg" },
          sessionToken: sessionTokenRef.current,
        },
        (results, status) => {
          setSearchLoading(false);
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            results
          ) {
            setPredictions(results);
            setShowPredictions(true);
          } else {
            setPredictions([]);
            setShowPredictions(false);
          }
        },
      );
    }, 300);
  };

  const handleSelectPrediction = (prediction) => {
    if (!placesServiceRef.current) return;

    placesServiceRef.current.getDetails(
      {
        placeId: prediction.place_id,
        fields: ["geometry", "formatted_address", "name"],
        sessionToken: sessionTokenRef.current,
      },
      (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place?.geometry?.location
        ) {
          setSelectedLocation({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });
          setSearchValue(
            place.formatted_address || place.name || prediction.description,
          );
        }
        setPredictions([]);
        setShowPredictions(false);
        sessionTokenRef.current =
          new window.google.maps.places.AutocompleteSessionToken();
      },
    );
  };

  const getMarkerIcon = () => {
    if (!isLoaded || !window.google) return undefined;

    return {
      path:
        "M12,2C8.13,2,5,5.13,5,9c0,5.25,7,13,7,13s7,-7.75,7,-13C19,5.13,15.87,2,12,2z " +
        "M12,11.5c-1.38,0,-2.5,-1.12,-2.5,-2.5s1.12,-2.5,2.5,-2.5s2.5,1.12,2.5,2.5s-1.12,2.5,-2.5,2.5z",
      fillColor: "#0051ff",
      fillOpacity: 1,
      strokeColor: "#0051ff",
      strokeWeight: 0,
      scale: 1.9,
      anchor: new window.google.maps.Point(12, 22),
    };
  };

  const onMapLoad = (map) => {
    mapInstanceRef.current = map;
    setMapReady(true);
  };

  const onMapUnmount = () => {
    if (markerInstanceRef.current) {
      markerInstanceRef.current.setMap(null);
      markerInstanceRef.current = null;
    }

    mapInstanceRef.current = null;
    setMapReady(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const map = mapInstanceRef.current;

      if (
        !isLoaded ||
        !mapReady ||
        !map ||
        !window.google ||
        !selectedLocation
      ) {
        if (markerInstanceRef.current) {
          markerInstanceRef.current.setMap(null);
          markerInstanceRef.current = null;
        }
        return;
      }

      const position = {
        lat: Number(selectedLocation.lat),
        lng: Number(selectedLocation.lng),
      };

      if (!markerInstanceRef.current) {
        markerInstanceRef.current = new window.google.maps.Marker({
          position,
          map,
          icon: getMarkerIcon(),
          draggable: locationMode !== "view",
        });

        markerInstanceRef.current.addListener("dragend", (e) => {
          setSelectedLocation({
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          });
        });
      } else {
        markerInstanceRef.current.setPosition(position);
        markerInstanceRef.current.setIcon(getMarkerIcon());
        markerInstanceRef.current.setDraggable(locationMode !== "view");
        markerInstanceRef.current.setMap(map);
      }
      map.panTo(position);
    }, 0);

    return () => clearTimeout(timer);
  }, [
    isLoaded,
    mapReady,
    selectedLocation,
    locationMode,
    locationType,
  ]);
  
  const [showConfirmAssign, setShowConfirmAssign] = useState(false);
  const [vehileMetrics, setVehileMetrics] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [fromVanId, setFromVanId] = useState(null);
  const location = useLocation();
  const status = location.state?.status;
  const navigate = useNavigate();

  const handleMapClick = async (event) => {
    if (locationMode === "view") return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setSelectedLocation({
      lat,
      lng,
    });
  };

  const handleSaveStartPoint = async () => {
if (
  !selectedLocation ||
  !Number.isFinite(Number(selectedLocation.lat)) ||
  !Number.isFinite(Number(selectedLocation.lng))
) {
  toast.error("Please select a location first");
  return;
}

    try {
      setSavingLocation(true);

      const vehicleId = selectedVanDetails?.id;

      let url = `${newHost}portal/door_step_vehicles/${vehicleId}/start-points`;

    if (locationMode === "edit") {
  if (!editingStartPointId) {
    toast.error("Start point ID is missing");
    console.log("selectedVanDetails:", selectedVanDetails);
    console.log("editingStartPointId:", editingStartPointId);
    return;
  }

  url = `${newHost}portal/door_step_vehicles/${vehicleId}/start-points/${editingStartPointId}`;
}

      const response =
        locationMode === "create"
          ? await axios.post(
              url,
              {
                latitude: selectedLocation.lat,
                longitude: selectedLocation.lng,
              },
              {
                headers: {
                  Authorization: "Bearer " + user?.token,
                },
              },
            )
          : await axios.put(
              url,
              {
                latitude: selectedLocation.lat,
                longitude: selectedLocation.lng,
              },
              {
                headers: {
                  Authorization: "Bearer " + user?.token,
                },
              },
            );

      toast.success(
        response.data?.message || "Start point updated successfully",
      );

      closeLocationModal();

      await handleVanDetails(vehicleId);

      await getVanList();
    } catch (error) {
      console.error("Start Point Error:", error);

      toast.error(
        error.response?.data?.message || "Failed to update start point",
      );
    } finally {
      setSavingLocation(false);
    }
  };

  const getVanList = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/vehicle-orders/auto-assignment/suggestions`,
         {
        headers: {
          Authorization: "Bearer " + user?.token,
        },
        params: { status }, 
      }
      );
      console.log(response.data.data.suggestions.vehicle_suggestions);
      const vehicleAssignment =
        response.data.data.suggestions.vehicle_suggestions;
      setVanList(vehicleAssignment);
    } catch (error) {
      console.log(error);
    }
  };

  const handleVanCard = (van) => {
    console.log("vaaan", van.id);
    setVanInfo(van);
    setShowOrderDetails(false);
    setShowDetails(false);
    $(".van-order-auto-assign").removeClass("selectedvanCard");
    $(`#van-${van.id}`).addClass("selectedvanCard");
  };

  const handleVanDetails = async (vanId) => {
    try {
      const response = await axios.get(
        `${newHost}portal/door_step_vehicles/${vanId}`,
        {
          headers: {
            Authorization: "Bearer " + user?.token,
          },
        }
      );
      console.log(response.data.data.door_step_vehicle);
      setSelectedVanDetails(response.data.data.door_step_vehicle);
      console.log(
        "CURRENT START POINT:",
        response.data.data.door_step_vehicle?.current_start_point,
      );
    } catch (error) {
      console.log(error);
    }
    setShowDetails(true);
    setShowOrderDetails(false);
  };

  const openLocationModal = (mode, location = null , type = "start_point") => {
    setLocationMode(mode);
    setLocationType(type);
    setSearchValue(location?.formatted_address || location?.address || "");
    
    if (!location) {
      setSelectedLocation(null);
      setEditingStartPointId(null);
      setShowLocationModal(true);
      return;
    }

  const lat = location.lat ?? location.latitude ?? location.coordinates?.lat;
  const lng = location.lng ?? location.longitude ?? location.coordinates?.lng;

  const parsedLat = Number(lat);
  const parsedLng = Number(lng);

  if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) {
    console.error("Invalid location data:", location);
    toast.error("Location coordinates are not available");
    return;
  }

  setSelectedLocation({
    lat: parsedLat,
    lng: parsedLng,
  });

    if (mode === "edit") {
      setEditingStartPointId(location.id ?? location.start_point_id ?? null);
    } else {
      setEditingStartPointId(null);
    }

    setShowLocationModal(true);
  };

  const closeLocationModal = () => {
    setShowLocationModal(false);
    setLocationMode(null);
    setSelectedLocation(null);
    setEditingStartPointId(null);
    setSearchValue("");
  };

  const handleOrderDetails = async (order) => {
    try {
      const response = await axios.get(
        `${newHost}portal/orders/${order.order?.id}`,
        {
          headers: {
            Authorization: "Bearer " + user?.token,
          },
        }
      );
      console.log(response.data.data);
      setSelectedOrderDetails(response.data.data.order);
      setShowOrderDetails(true);
        setShowDetails(false);
    } catch (error) {
      console.log(error);
    }
    console.log(order);
  };

  useEffect(() => {
    getVanList();
  }, []);

  useEffect(() => {
    if (vanList.length > 0) {
      if (!vanInfo?.id) {
        const firstVan = vanList[0];
        setVanInfo(firstVan.vehicle);
        setVanOrders(firstVan.suggested_orders);
        setVehileMetrics(firstVan.vehicle_metrics);
        $(".van-order-auto-assign").removeClass("selectedvanCard");
        $(`#van-${firstVan.vehicle?.id}`).addClass("selectedvanCard")
        return;
      }

      const current = vanList.find(v => v.vehicle.id == vanInfo.id);
      if (current) {
        setVanOrders(current.suggested_orders);
        setVehileMetrics(current.vehicle_metrics);
        $(".van-order-auto-assign").removeClass("selectedvanCard");
        $(`#van-${vanInfo.id}`).addClass("selectedvanCard");
      }
    }
  }, [vanList]);

  const handleSelection = (id) => {
    console.log("idddd", id);
    console.log(selectVanModal);

    setSelectedVanId(id);
    $(".stuff-card").removeClass("selectedVan");
    $(".stuff-card").removeClass("unSelectedVan");

    $("#" + id).addClass("selectedVan");
  };

  const handleTransModalShow = () => {
    setSelectVanModal(true);
  };

  const handleTransferModalClose = () => {
    setSelectVanModal(false);
  };

  const handleConfirmAssignShow = () => {
    setShowConfirmAssign(true);
  };

  const handleConfirmAssignClose = () => {
    setShowConfirmAssign(false);
  };

  const handleTransferOrders = () => {
    if (!fromVanId || !selectedVanId || selectedOrders.length == 0) return;

    setVanList((prev) => {
      let sourceVan = prev.find((v) => v.vehicle.id == fromVanId);

      const movedOrders = sourceVan.suggested_orders.filter((o) =>
        selectedOrders.includes(o.order.id)
      );

      return prev.map((v) => {
        if (v.vehicle.id == fromVanId) {
          return {
            ...v,
            suggested_orders: v.suggested_orders.filter(
              (o) => !selectedOrders.includes(o.order.id)
            ),
          };
        }

        if (v.vehicle.id === selectedVanId) {
          return {
            ...v,
            suggested_orders: [...v.suggested_orders, ...movedOrders],
          };
        }

        return v;
      });
    });

    setSelectedOrders([]);
    setFromVanId(null);
    setSelectedVanId(null);
    setSelectVanModal(false);
  };

  const filteredVans = vanList.filter(
    (van) =>
      !van.suggested_orders.some((order) =>
        selectedOrders.includes(order.order.id)
      )
  );

  const confirmAssignOrder = async () => {
    try {
      const assignments = vanList.flatMap((van) =>
        van.suggested_orders.map((vanOrder) => ({
          order_id: vanOrder.order.id,
          vehicle_id: van.vehicle.id,
        }))
      );

      if (assignments.length == 0) {
        toast.error("No arranged orders to assign!");
        return;
      }

      const response = await axios.post(
        `${newHost}portal/vehicle-orders/auto-assignment/execute`,
        { assignments },
        { headers: { Authorization: "Bearer " + user?.token } }
      );

      toast.success(response.data.message);
      navigate("/orders", { state: { status: "assigned" } });
      console.log(response.data);

      setShowConfirmAssign(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message);
    }
  };

  const handleOrderSelect = (orderId, vanId, order) => {
      setFromVanId(vanId);

      setSelectedOrders((prev) =>
        prev.includes(orderId)
          ? prev.filter((id) => id !== orderId)
          : [...prev, orderId]
      );
  };

  // routing

  const [mode, setMode] = useState("transfer"); 

  const [routeOrders, setRouteOrders] = useState([]);

  const [routeData, setRouteData] = useState(null);

  /* ================= API Call ================= */

  const fetchOptimizedRoute = async () => {
    if (routeOrders.length < 2) {
      toast.error("Select at least 2 orders for routing");
      return;
    }

    const body = {
      points: routeOrders.map((p) => ({
        lat: p.lat,
        lng: p.lng,
      })),
    };

    try {
      const response = await fetch(`${newHost}portal/optimized-route`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user?.token,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      setRouteData(data);
    } catch (err) {
      console.error("Route API Error:", err);
    } 
  };

  /* ================= Build Google Map URL ================= */

  const buildGoogleRouteUrl = () => {
  if (routeOrders.length < 2) return null;

  const origin = `${routeOrders[0].lat},${routeOrders[0].lng}`;
  const destination = `${routeOrders[routeOrders.length - 1].lat},${
    routeOrders[routeOrders.length - 1].lng
  }`;

  const waypoints = routeOrders
    .slice(1, -1)
    .map((p) => `${p.lat},${p.lng}`)
    .join("|");

  let url = `https://www.google.com/maps/embed/v1/directions?key=${GOOGLE_MAPS_KEY}&origin=${origin}&destination=${destination}`;

  if (waypoints) {
    url += `&waypoints=${encodeURIComponent(waypoints)}`;
  }

  return url;
  };
  
  useEffect(() => {
    if (routeOrders.length >= 2) {
      fetchOptimizedRoute();
    } else {
      setRouteData(null);
    }
  }, [routeOrders]);

  useEffect(() => {
    if (!showLocationModal || !mapReady || !mapInstanceRef.current) return;

    const timer = setTimeout(() => {
      window.google.maps.event.trigger(mapInstanceRef.current, "resize");

      if (selectedLocation) {
        mapInstanceRef.current.setCenter({
          lat: Number(selectedLocation.lat),
          lng: Number(selectedLocation.lng),
        });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [showLocationModal, mapReady, selectedLocation]);

  return (
    <>
      <Modal
        show={showLocationModal}
        onHide={closeLocationModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {locationMode === "create"
              ? "Select Start Point"
              : locationMode === "edit"
                ? "Edit Start Point"
                : "Location"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {locationMode !== "view" && isLoaded && (
            <div className="location-search-wrapper mb-3">
              <div className="location-search-box">
                <Search fontSize="small" className="location-search-icon" />
                <input
                  type="text"
                  className="location-search-input"
                  placeholder="دور على مكان أو عنوان..."
                  value={searchValue}
                  onChange={handleSearchChange}
                  onFocus={() =>
                    predictions.length > 0 && setShowPredictions(true)
                  }
                  onBlur={() =>
                    setTimeout(() => setShowPredictions(false), 150)
                  }
                />
                {searchLoading && <span className="location-search-spinner" />}
              </div>

              {showPredictions && predictions.length > 0 && (
                <div className="location-predictions">
                  {predictions.map((prediction) => (
                    <div
                      key={prediction.place_id}
                      className="location-prediction-item"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleSelectPrediction(prediction);
                      }}
                    >
                      <LocationOn
                        fontSize="small"
                        className="location-prediction-icon"
                      />
                      <div className="location-prediction-text">
                        <span className="location-prediction-main">
                          {prediction.structured_formatting?.main_text ||
                            prediction.description}
                        </span>
                        {prediction.structured_formatting?.secondary_text && (
                          <span className="location-prediction-secondary">
                            {prediction.structured_formatting.secondary_text}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div
            style={{
              height: "450px",
              width: "100%",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {isLoaded && (
              <>
                {console.log(
                  "selectedLocation:",
                  selectedLocation,
                  "isLoaded:",
                  isLoaded,
                )}
                <GoogleMap
                  mapContainerStyle={{ width: "100%", height: "100%" }}
                  center={
                    selectedLocation || {
                      lat: 30.04442,
                      lng: 31.235712,
                    }
                  }
                  zoom={16}
                  onLoad={onMapLoad}
                  onUnmount={onMapUnmount}
                  onClick={locationMode === "view" ? undefined : handleMapClick}
                  options={{
                    clickableIcons: locationMode !== "view",
                    disableDoubleClickZoom: locationMode === "view",
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: locationMode !== "view",
                    zoomControl: true,
                    gestureHandling: "greedy",
                  }}
                />
              </>
            )}
          </div>
          {selectedLocation && (
            <div className="mt-3 p-3 bg-light rounded-3">
              <div className="d-flex justify-content-between">
                <span className="text-muted">Latitude</span>
                <strong>{Number(selectedLocation.lat).toFixed(6)}</strong>
              </div>
              <div className="d-flex justify-content-between mt-1">
                <span className="text-muted">Longitude</span>
                <strong>{Number(selectedLocation.lng).toFixed(6)}</strong>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-light"
            onClick={closeLocationModal}
          >
            Close
          </button>
          {locationMode !== "view" && (
            <button
              type="button"
              className="btn btn-dark px-4"
              disabled={!selectedLocation || savingLocation}
              onClick={handleSaveStartPoint}
            >
              {savingLocation
                ? "Saving..."
                : locationMode === "edit"
                  ? "Update Start Point"
                  : "Save Start Point"}
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showConfirmAssign}
        onHide={handleConfirmAssignClose}
        className=""
      >
        <>
          <div className="text-center py-4">
            {" "}
            <h3>Confirm Deletion</h3>
          </div>

          <div className="text-center py-2  px-3">
            <h6 style={{ color: "#535353" }} className="">
              Are you sure you want to confirm the current arrangement? Once
              confirmed, all arranged orders will be officially assigned to
              agents and vans. Please make sure all orders are arranged
              correctly
            </h6>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-center gap-3 py-3">
              <button
                onClick={handleConfirmAssignClose}
                className="btn btn-light px-5"
              >
                Cancel
              </button>
              <button
                onClick={confirmAssignOrder}
                className="btn btn-dark px-5"
              >
                Confirm & Assign
              </button>
            </div>
          </div>
        </>
      </Modal>
      <Modal show={selectVanModal} onHide={handleTransferModalClose} size="xl">
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black">Select Van</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="container rounded-2 overflow-y-scroll vh-100"
          style={{}}
        >
          <div className="row">
            {filteredVans.map((van) => {
              const getStaffByRole = (slug) => {
                const staff = van?.vehicle?.staffing?.current_staff?.find(
                  (staff) => staff?.job_titles[0]?.slug == slug,
                );
                return staff;
              };
              return (
                <div
                  id={van?.vehicle?.id}
                  onClick={() =>
                    selectVanModal && handleSelection(van.vehicle?.id)
                  }
                  style={{ minHeight: 50 }}
                  className={`col-12 col-lg-3 col-md-3 ${
                    selectVanModal && "stuff-card"
                  }`}
                >
                  <div
                    style={{
                      overflow: "hidden",
                    }}
                    key={van?.vehicle.id}
                    className="rounded-2 card p-2 bg-light my-2 custom-hight-mobile"
                  >
                    <div className="d-flex custom-card-sm align-items-center justify-content-between mt-1 mx-2">
                      <div className="d-flex align-items-center gap-1">
                        <img
                          style={{ width: 20 }}
                          src={
                            van?.model?.brand?.logo_path
                              ? `${newImageUrl}${van?.model?.brand?.logo_path}`
                              : defaultImage
                          }
                          alt="brand-image"
                        />

                        <h6
                          style={{ fontSize: 10, marginInline: 3 }}
                          className="m-0 "
                        >
                          {van?.vehicle.name}
                        </h6>
                      </div>
                      <h6 className="fs-6 fw-bold">Van # {van?.vehicle.id}</h6>
                    </div>

                    <div className="d-flex custom-card-sm justify-content-center align-items-center custom-hight-img-card mx-4 my-3 ">
                      <img
                        className="img-fluid"
                        src={
                          van?.vehicle.profile_photo_url
                            ? `${newImageUrl}${van?.vehicle.profile_photo_url}`
                            : defaultImage
                        }
                        alt="van-image"
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "fill",
                        }}
                      />
                    </div>
                    <div className="my-2">
                      <div className="upload-file-responsive">
                        <h6 className="main-text-color label-van m-0">
                          Van Capacity
                        </h6>
                        <div
                          className="progress my-1 "
                          style={{ height: "10px" }}
                        >
                          <div
                            className={` ${
                              van?.vehicle?.capacity > 7 &&
                              van?.vehicle?.capacity <= 10
                                ? "bg-success"
                                : van?.vehicle?.capacity > 3 &&
                                    van?.capacity < 7
                                  ? "bg-warning"
                                  : van?.vehicle?.capacity == 0
                                    ? "bg-transparent"
                                    : van?.vehicle?.capacity > 0 &&
                                        van?.vehicle?.capacity < 3
                                      ? "bg-danger"
                                      : ""
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                van?.vehicle?.capacity == 10
                                  ? "100%"
                                  : van?.vehicle?.capacity > 7
                                    ? "90%"
                                    : van?.vehicle?.capacity > 3 &&
                                        van?.vehicle?.capacity < 7
                                      ? "50%"
                                      : van?.vehicle?.capacity > 0 &&
                                          van?.vehicle?.capacity < 3
                                        ? "30%"
                                        : van?.vehicle?.capacity == 0
                                          ? "0%"
                                          : "",
                            }}
                            aria-valuenow={van?.vehicle?.capacity}
                            aria-valuemin="0"
                            aria-valuemax="10"
                          ></div>
                        </div>
                      </div>

                      <div className="upload-file-responsive">
                        <h6 className="main-text-color label-van m-0">
                          Working hours
                        </h6>
                        <div
                          className="progress my-1 "
                          style={{ height: "10px" }}
                        >
                          <div
                            className={` ${
                              van?.vehicle?.capacity > 7 &&
                              van?.vehicle?.capacity <= 10
                                ? "bg-success"
                                : van?.vehicle?.capacity > 3 &&
                                    van?.vehicle?.capacity < 7
                                  ? "bg-warning"
                                  : van?.vehicle?.capacity == 0
                                    ? "bg-transparent"
                                    : van?.vehicle?.capacity > 0 &&
                                        van?.vehicle?.capacity < 3
                                      ? "bg-danger"
                                      : ""
                            }`}
                            role="progressbar"
                            style={{
                              width:
                                van?.vehicle?.capacity == 10
                                  ? "100%"
                                  : van?.vehicle?.capacity > 7
                                    ? "90%"
                                    : van?.vehicle?.capacity > 3 &&
                                        van?.vehicle?.capacity < 7
                                      ? "50%"
                                      : van?.vehicle?.capacity > 0 &&
                                          van?.vehicle?.capacity < 3
                                        ? "30%"
                                        : van?.vehicle?.capacity === 0
                                          ? "0%"
                                          : "",
                            }}
                            aria-valuenow={van?.vehicle?.capacity}
                            aria-valuemin="0"
                            aria-valuemax="10"
                          ></div>
                        </div>
                      </div>

                      <div className="d-flex custom-card-sm justify-content-between align-items-center mt-3">
                        <h6 className="main-text-color label-van m-0">
                          Services Categories
                        </h6>

                        <div className="">
                          {van.vehicle?.service_categories?.length > 0 ? (
                            <>
                              {van.vehicle?.service_categories.map(
                                (service) => (
                                  <img
                                    className="service-icon"
                                    src={newImageUrl + service.icon_url}
                                    alt="service-icon"
                                  />
                                ),
                              )}
                            </>
                          ) : (
                            <div className="">
                              <p className="m-0 label-van">
                                No Available Services
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
                        <h6 className="main-text-color m-0 label-van">
                          Supervisor
                        </h6>
                        {van?.vehicle?.supervisor?.length > 0 ? (
                          van.vehicle?.supervisor.map(
                            (supervisor) =>
                              `${supervisor.first_name}${supervisor.last_name}`,
                          )
                        ) : (
                          <div className="">
                            <p className="m-0 label-van">
                              No Available Supervisor
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
                        <h6 className="main-text-color m-0 label-van">
                          Driver
                        </h6>
                        <h6 className=" m-0 label-van">
                          {getStaffByRole("driver")?.name || (
                            <div className="">
                              <p className="m-0 label-van">
                                No Available Driver
                              </p>
                            </div>
                          )}
                        </h6>
                      </div>

                      <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
                        <h6 className="main-text-color m-0 label-van">
                          Technician
                        </h6>
                        <h6 className=" m-0 label-van">
                          {getStaffByRole("technician")?.name || (
                            <div className="">
                              <p className="m-0 label-van">
                                No Available Technician
                              </p>
                            </div>
                          )}
                        </h6>
                      </div>

                      <div className="d-flex custom-card-sm justify-content-between align-items-center my-1">
                        <h6 className="main-text-color m-0 label-van">
                          Engineer
                        </h6>
                        <h6 className=" m-0 label-van">
                          {getStaffByRole("engineer")?.name || (
                            <div className="">
                              <p className="m-0 label-size">
                                No Available Engineer
                              </p>
                            </div>
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>

        <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
          <button onClick={handleTransferOrders} className="btn btn-dark px-5">
            Save
          </button>
          <button
            type="reset"
            onClick={() => handleTransferModalClose()}
            className="btn btn-light px-5"
          >
            Cancel
          </button>
        </div>
      </Modal>
      <div className="m-4 ">
        <div className="d-flex justify-content-between align-items-center header-responsive my-3">
          <h5 className="m-0 fw-semibold">Vehicles Arrangement Overview</h5>
          <div className=" btn-vans-responsive">
            <button
              onClick={handleConfirmAssignShow}
              className="btn btn-dark rounded-2 text-white d-block"
            >
              Confirm Auto Arrange
            </button>
          </div>
        </div>
        <div className="row m-2">
          {/* Orders */}
          <div className=" col-3 ">
            <div className="border-bottom w-100 py-2  ">
              <div className="d-flex gap-2 align-items-center my-1 ">
                <h5 className="m-0">Vehicles</h5>
                <span className="order-length">{vanList.length}</span>
              </div>
              <div
                style={{ height: "90px" }}
                className="row w-100 mt-3 overflow-x-hidden overflow-y-scroll scrollbar-hidden m-auto "
              >
                {vanList.map((van) => (
                  <div className="col-lg-3 col-md-6 col-12">
                    <div
                      key={van.vehicle?.id}
                      id={`van-${van.vehicle?.id}`}
                      onClick={() => {
                        handleVanCard(van?.vehicle);
                        console.log(van?.suggested_orders);
                        setVanOrders(van?.suggested_orders);
                        setVehileMetrics(van?.vehicle_metrics);
                      }}
                      className={`van-order-auto-assign border van-circle d-flex justify-content-center align-items-center my-1 p-1`}
                    >
                      <img
                        className="w-75 h-75 "
                        src={
                          van.vehicle?.profile_photo_path
                            ? `${newImageUrl}${van.vehicle?.profile_photo_path}`
                            : vehicle
                        }
                        alt=""
                      />
                    </div>
                    <div className="text-center">
                      <h6 style={{ fontSize: "14px" }} className="ms-1 my-2">
                        van {van.vehicle?.id}
                      </h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="van-container d-flex justify-content-between align-items-center my-2 position-relative">
              <div className="d-flex align-items-center justify-content-between">
                <div className="mx-2">
                  <p className="my-1 fs-6 fw-bold">Van {vanInfo?.id}</p>
                </div>
              </div>
              <div
                className="d-flex justify-content-center align-items-center cursor position-relative"
                onClick={() => handleVanDetails(vanInfo.id)}
              >
                <h6 className="fw-bold m-0">Van Info</h6>
                <div
                  onClick={(e) => e.stopPropagation()}
                  className={`side-container ${
                    showDetails ? "open" : "d-none"
                  }`}
                >
                  <div className="side-header">
                    <h6 className="fw-bold">Van # {selectedVanDetails?.id}</h6>
                    <span
                      className="close-btn"
                      onClick={() => setShowDetails(false)}
                    >
                      <Close />
                    </span>
                  </div>
                  <div className="my-3">
                    <p className="text-xs-size main-text-color m-0">Agent</p>
                    <div className="d-flex gap-2 justify-content-between align-items-center mt-2">
                      <div className="vanImage">
                        <img
                          className="w-100"
                          src={
                            selectedVanDetails?.supervisor?.[0]
                              ?.profile_photo_path
                              ? `${newImageUrl}${selectedVanDetails?.supervisor?.[0]?.profile_photo_path}`
                              : vehicle
                          }
                          alt=""
                        />
                      </div>
                      <h6 className="m-0 text-black">
                        {selectedVanDetails?.supervisor?.[0]?.name}
                      </h6>
                    </div>
                  </div>
                  <div className="upload-file-responsive">
                    <div className="d-flex align-content-center justify-content-between">
                      <h6 className="main-text-color label-van m-0">
                        Van Capacity
                      </h6>
                      <h6 className="label-van m-0">
                        {selectedVanDetails.remaining_hours}{" "}
                        <span className="main-text-color">/ hours</span>
                      </h6>
                    </div>
                    <div className="progress my-1 " style={{ height: "10px" }}>
                      <div
                        className={` ${
                          selectedVanDetails?.remaining_hours > 7 &&
                          selectedVanDetails?.remaining_hours <= 10
                            ? "bg-success"
                            : selectedVanDetails?.remaining_hours > 3 &&
                                selectedVanDetails?.remaining_hours < 7
                              ? "bg-warning"
                              : selectedVanDetails?.remaining_hours == 0
                                ? "bg-transparent"
                                : selectedVanDetails?.remaining_hours > 0 &&
                                    selectedVanDetails?.remaining_hours < 3
                                  ? "bg-danger"
                                  : ""
                        }`}
                        role="progressbar"
                        style={{
                          width:
                            selectedVanDetails?.remaining_hours == 10
                              ? "100%"
                              : selectedVanDetails?.remaining_hours > 7
                                ? "90%"
                                : selectedVanDetails?.remaining_hours > 3 &&
                                    selectedVanDetails?.remaining_hours < 7
                                  ? "50%"
                                  : selectedVanDetails?.remaining_hours > 0 &&
                                      selectedVanDetails?.remaining_hours < 3
                                    ? "30%"
                                    : selectedVanDetails?.remaining_hours == 0
                                      ? "0%"
                                      : "",
                        }}
                        aria-valuenow={selectedVanDetails?.remaining_hours}
                        aria-valuemin="0"
                        aria-valuemax="10"
                      ></div>
                    </div>
                  </div>
                  <div className="my-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="text-xs-size main-text-color m-0">
                        Start Point
                      </h6>

                      {selectedVanDetails?.current_start_point && (
                        <button
                          type="button"
                          className="btn btn-sm p-0 border-0 bg-transparent"
                          title="Edit start point"
                          onClick={() =>
                            openLocationModal(
                              "edit",
                              selectedVanDetails.current_start_point,
                              "start_point",
                            )
                          }
                        >
                          <Edit fontSize="small" />
                        </button>
                      )}
                    </div>

                    {selectedVanDetails?.current_start_point ? (
                      <div
                        className="mt-2 p-2 rounded-3 border bg-light cursor"
                        onClick={() =>
                          openLocationModal(
                            "view",
                            selectedVanDetails.current_start_point,
                            "start_point",
                          )
                        }
                      >
                        <div className="d-flex align-items-start gap-2">
                          <LocationOn
                            fontSize="small"
                            className="text-danger mt-1"
                          />

                          <div>
                            <p className="m-0 text-sm-size fw-semibold">
                              {selectedVanDetails.current_start_point
                                ?.formatted_address ||
                                selectedVanDetails.current_start_point
                                  ?.address ||
                                "Location available"}
                            </p>

                            <p className="m-0 mt-1 text-xs-size text-muted">
                              View location on map
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm mt-2 w-100"
                        onClick={() =>
                          openLocationModal("create", null, "start_point")
                        }
                      >
                        <LocationOn fontSize="small" className="me-1" />
                        Select your start point
                      </button>
                    )}
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">
                      Current Location
                    </h6>

                    {selectedVanDetails?.current_location ? (
                      <div
                        className="mt-2 p-2 rounded-3 border bg-light cursor"
                        onClick={() =>
                          openLocationModal(
                            "view",
                            selectedVanDetails.current_location,
                            "current_location",
                          )
                        }
                      >
                        <div className="d-flex align-items-start gap-2">
                          <LocationOn
                            fontSize="small"
                            className="text-primary mt-1"
                          />

                          <div>
                            <p className="m-0 text-sm-size fw-semibold">
                              {selectedVanDetails.current_location
                                ?.full_address ||
                                selectedVanDetails.current_location?.address ||
                                "Current location"}
                            </p>

                            <p className="m-0 mt-1 text-xs-size text-muted">
                              View on map
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="m-0 text-sm-size text-muted">
                        No current location available
                      </p>
                    )}
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">Orders No.</h6>
                    <p className="m-0 text-sm-size">
                      {vehileMetrics?.order_count} Orders
                    </p>
                  </div>
                  {selectedVanDetails?.current_stuff?.map((staff) => (
                    <div className="my-3">
                      <p className="text-xs-size main-text-color m-0">
                        {staff.job_title.title}
                      </p>
                      <div className="d-flex gap-2 align-items-center">
                        <div className="vanImage">
                          <img
                            className="w-100 h-100 rounded-5"
                            src={
                              staff.profile_photo_url
                                ? `${newImageUrl}${staff.profile_photo_url}`
                                : defaultImage
                            }
                            alt=""
                          />
                        </div>
                        <h6 className="m-0">{staff.name}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="position-relative">
              <div
                style={{ height: "300px" }}
                className="orders overflow-x-hidden overflow-y-auto scrollbar-hidden"
              >
                {vanOrders.map((order) => (
                  <div
                    key={order?.order?.id}
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                    }}
                    className="order-item"
                  >
                    <div className="d-flex justify-content-between align-items-center van-container">
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          checked={
                            mode === "transfer"
                              ? selectedOrders.includes(order.order.id)
                              : routeOrders.some((o) => o.id === order.order.id)
                          }
                          onChange={() => {
                            if (mode === "transfer") {
                              handleOrderSelect(order.order.id, vanInfo.id);
                            }

                            if (mode === "route") {
                              const lat = Number(order.order.address?.latitude);
                              const lng = Number(
                                order.order.address?.longitude,
                              );

                              if (!lat || !lng) {
                                toast.error("Order has no valid location");
                                return;
                              }
                              setRouteOrders((prev) => {
                                const exists = prev.some(
                                  (o) => o.id === order.order.id,
                                );
                                return exists
                                  ? prev.filter((o) => o.id !== order.order.id)
                                  : [...prev, { id: order.order.id, lat, lng }];
                              });
                            }
                          }}
                        />
                        <p className="my-0 mx-3 fw-bold">
                          Order #{order.order.id}
                        </p>
                      </div>
                      <div
                        className="cursor position-relative"
                        onClick={() => handleOrderDetails(order)}
                      >
                        <p className="my-0 text-muted fw-semibold">
                          View Details
                        </p>
                      </div>
                    </div>

                    <div className="my-2 d-flex align-items-center mx-3">
                      <img
                        style={{ width: "30px" }}
                        src={defaultImage}
                        className=""
                        alt=""
                      />
                      <p className="my-0 mx-2 text-sm-size fw-semibold">
                        {order.order.customer?.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              {showOrderDetails && (
                <div
                  className="order-side-container open"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="side-header d-flex justify-content-between align-items-center">
                    <h6 className="fw-bold">
                      Order #{selectedOrderDetails?.id}
                    </h6>
                    <span
                      className="close-btn cursor"
                      onClick={() => setShowOrderDetails(false)}
                    >
                      <Close />
                    </span>
                  </div>
                  <div className="my-3">
                    <p className="text-xs-size main-text-color m-0">
                      Client Name
                    </p>
                    <div className="d-flex gap-2 align-items-center">
                      <div className="vanImage">
                        <img
                          className="w-100 h-100"
                          src={
                            selectedOrderDetails?.user?.profile_photo_path
                              ? `${newImageUrl}${selectedOrderDetails?.user?.profile_photo_path}`
                              : defaultImage
                          }
                          alt=""
                        />
                      </div>
                      <h6 className="m-0">
                        {selectedOrderDetails?.user?.name}
                      </h6>
                    </div>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">Area</h6>
                    <p className="m-0 text-sm-size">
                      {selectedOrderDetails?.address?.area}
                    </p>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">
                      Preferred Time
                    </h6>
                    <p className="m-0 text-sm-size">{`${selectedOrderDetails?.scheduled_from} to ${selectedOrderDetails?.scheduled_to}`}</p>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">Cost</h6>
                    <p className="m-0 text-sm-size fw-bold">
                      {selectedOrderDetails?.total}
                    </p>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">
                      Estimated Time
                    </h6>
                    <p className="m-0 text-sm-size fw-bold">
                      {selectedOrderDetails?.estimated_duration_minutes} minutes
                    </p>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">Status</h6>
                    <div className="d-flex gap-2 align-items-center">
                      <Circle
                        sx={{
                          width: "15px",
                          height: "15px",
                          color: selectedOrderDetails?.order_status?.color,
                        }}
                      />
                      <p className="m-0 text-sm-size">
                        {selectedOrderDetails?.order_status?.label}
                      </p>
                    </div>
                  </div>
                  <div className="my-3">
                    <h6 className="text-xs-size main-text-color">services</h6>
                    {selectedOrderDetails?.categories?.length > 0 ? (
                      selectedOrderDetails?.categories?.map((category) => (
                        <>
                          <div className="d-flex gap-2 align-items-center ">
                            <div
                              style={{ width: "30px", height: "30px" }}
                              className=""
                            >
                              <img
                                className="w-100 h-100"
                                src={
                                  category.icon_url
                                    ? `${newImageUrl}${category?.icon_url}`
                                    : defaultImage
                                }
                                alt=""
                              />
                            </div>
                            <p className="m-0 text-sm-size fw-semibold">
                              {category.name}
                            </p>
                          </div>
                          {category.subcategories?.map((service) => (
                            <div style={{ direction: "rtl" }} className="">
                              <div className="my-2 d-flex justify-content-between align-items-center">
                                <h6 className="text-sm-size main-text-color m-0">
                                  {service.name}
                                </h6>
                                <p className="m-0 text-sm-size fw-semibold">
                                  {formatNumber(service.total_price)} EGP
                                </p>
                              </div>
                            </div>
                          ))}
                        </>
                      ))
                    ) : (
                      <>
                        <div>No available services</div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex gap-3 mb-3">
              <button
                className={`btn ${
                  mode === "transfer" ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => {
                  setMode("transfer");
                  setRouteOrders([]);
                }}
              >
                Transfer Orders
              </button>

              <button
                className={`btn px-4 ${
                  mode === "route" ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => {
                  setMode("route");
                  setSelectedOrders([]);
                }}
              >
                Build Route
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 button-responsive fixed-footer border-top ">
              <button
                disabled={mode !== "transfer"}
                className="btn btn-outline-danger px-2"
              >
                Remove
              </button>

              <button
                disabled={mode !== "transfer"}
                onClick={handleTransModalShow}
                className="btn btn-dark"
              >
                Transfer
              </button>
            </div>
          </div>
          {/* Map  */}
          <div className=" col-9">
            {/* Distance & Duration */}
            {routeData && (
              <div className="d-flex justify-content-between bg-light px-3 py-2">
                <p className="fw-semibold mb-0">
                  Total Distance: {routeData?.total_distance}
                </p>
                <p className="fw-semibold mb-0">
                  Estimated Time: {routeData?.total_duration}
                </p>
              </div>
            )}
            {/* Map */}
            <iframe
              src={
                buildGoogleRouteUrl() ||
                `https://www.google.com/maps/embed/v1/view?key=${GOOGLE_MAPS_KEY}&center=30.0444,31.2357&zoom=12`
              }
              width="100%"
              height="520"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              title="Orders Route"
            />
          </div>
        </div>
      </div>
    </>
  );
}
